import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulb = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .9,
		d: "M4 11H6",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .9,
		d: "M3 8C3 6 1.5 5.5 1.5 4C1.5 2.5 2.5 1 5 1C7.5 1 8.5 2.5 8.5 4C8.5 5.5 7 6 7 8",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgBulb);
export { ForwardRef as ReactComponent };
